import { render, staticRenderFns } from "./Bendetail.vue?vue&type=template&id=2e3b5580&scoped=true&"
import script from "./Bendetail.vue?vue&type=script&lang=js&"
export * from "./Bendetail.vue?vue&type=script&lang=js&"
import style0 from "./Bendetail.vue?vue&type=style&index=0&id=2e3b5580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b5580",
  null
  
)

export default component.exports